import moment from 'moment';

import { Http } from '../../../support';
import GetNewListHighlighted from '../../../support/GetNewListHighlighted';

const from = moment().subtract(1, 'month').format('YYYY-MM-DD');
const to = moment().format('YYYY-MM-DD');

export const initialState = {
  busy: false,
  data: [],
  selectedRows: [],
  selectedRowKeys: [],
  result: undefined,
  error: undefined,
  pagination: {
    limit: 25,
    from,
    to,
    tipo: ['usuarios'],
  },
};

const setSelectedRows = (store, data) => {
  store.setState((state) => {
    const { list } = state.app.usuarios;

    state.app.usuarios.list = {
      ...list,
      ...data,
    };
  });
};

const setSelectedRowsKeys = (store, data) => {
  store.setState((state) => {
    const { list } = state.app.usuarios;

    state.app.usuarios.list = {
      ...list,
      ...data,
    };
  });
};

const change = (store, data) => {
  store.setState((state) => {
    const { list } = state.app.usuarios;

    state.app.usuarios.list.data = {
      ...list.data,
      ...data,
    };
  });
};

const paginate = async (store, params) => {
  store.setState((state) => {
    const { list } = state.app.usuarios;

    state.app.usuarios.list = {
      ...list,
      result: undefined,
      error: undefined,
      busy: true,
      pagination: {
        ...list.pagination,
        ...params,
      },
    };
  });

  try {
    const { pagination } = store.state.app.usuarios.list;

    const body = {
      ...pagination,
      ...params,
      links: undefined,
    };
    const response = await Http.get(`/api/usuarios`, { params: body });

    store.setState((state) => {
      const { list } = state.app.usuarios;

      state.app.usuarios.list = {
        ...list,
        ...initialState,
        data: response.data,
        pagination: {
          ...list.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.app.usuarios.list.busy = false;
      state.app.usuarios.list.error = error.data || error;
    });
  }
};

const highlight = (store, item) => {
  const fullList = store.state.app.usuarios.list.data;

  const newList = GetNewListHighlighted.make(fullList, item, true);

  store.setState((state) => {
    state.app.usuarios.list.data = newList;
  });

  setTimeout(() => {
    const newList = GetNewListHighlighted.make(fullList, item, false);

    store.setState((state) => {
      state.app.usuarios.list.data = newList;
    });
  }, 5000);
};

const reset = (store) => {
  store.setState((state) => {
    state.app.usuarios.list = {
      ...initialState,
    };
  });
};

const UsuarioListStore = {
  state: () => initialState,
  actions: {
    change,
    highlight,
    setSelectedRows,
    setSelectedRowsKeys,
    paginate,
    reset,
  },
};

export default UsuarioListStore;
